// IE 2026 09 30 / ODOO-343433: клик по строке грида REPORT2 → переход на другую страницу ТОГО ЖЕ стола с чипсом (селектором), взятым из значения строки.
// Модуль без Vue/DOM/стора: конфиг, значение строки и новые строки WHERE стола — чистые функции (юнит: tests/unit/pageGotoChip.test.mjs).
//
// Конфиг — в параметрах виджета отчёта, doc.params.row_click (рядом с doc.params.drilldown_widgets):
//   { action: 'page_goto_chip', page: '<id страницы стола>', chip_binding: '<binding чипса-селектора стола>', row_binding: '<колонка строки со значением>',
//     trigger?: 'row_header' (по умолчанию: клик по заголовку строки — номер строки слева; форма ячейки по одиночному клику Item НЕ подменяется) | 'cell' (клик по ячейке данных),
//     workspace?: '<id другого стола>' (страница открывается в нём; нет / тот же стол — страница текущего стола),
//     column?: '<binding колонки, клик по которой срабатывает при trigger:cell; нет — любая ячейка данных>', condition?: 'in', use?: false (выключить) }
// Чипсы ставятся ТОЛЬКО в памяти (params.WHERE стола на клиенте); запись стола / настройки пользователя не сохраняются (правило 13).

import { guidePlay_goto } from './guidePlay.js'   // переход роутером и ожидание активной страницы — как у показа «Open in demo»

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const clone = (x) => JSON.parse(JSON.stringify(x === undefined ? null : x))

export const PAGE_GOTO_CHIP_ACTION = 'page_goto_chip'

// нормализованный конфиг из doc.params.row_click; null — не настроен / неполон / выключен
export function pageGotoChip_config(params) {
    const c = isObj(params) ? params.row_click : null
    if (!isObj(c) || c.use === false || str(c.action) !== PAGE_GOTO_CHIP_ACTION) return null
    const page = str(c.page).trim(), chip_binding = str(c.chip_binding).trim(), row_binding = str(c.row_binding).trim()
    const trigger = str(c.trigger).trim() === 'cell' ? 'cell' : 'row_header'
    // demo-webscm 2026 11 02 / Odoo 347310 (page «Сьогодні», tasks list): page_binding / chips_binding — страница и чипсы берутся ИЗ СТРОКИ (один список задач ведёт
    // на разные страницы стола); page / chip_binding + row_binding — запасной вариант для строки без своих значений. Без этих ключей — прежний конфиг, без изменений.
    const page_binding = str(c.page_binding).trim(), chips_binding = str(c.chips_binding).trim()
    if (page_binding || chips_binding) {
        if (!page && !page_binding) return null
        return { page, chip_binding, row_binding, trigger, workspace: str(c.workspace).trim(), column: str(c.column).trim(), condition: str(c.condition).trim() || 'in',
            page_binding, chips_binding }
    }
    if (!page || !chip_binding || !row_binding) return null
    return { page, chip_binding, row_binding, trigger, workspace: str(c.workspace).trim(), column: str(c.column).trim(), condition: str(c.condition).trim() || 'in' }
}

// demo-webscm 2026 11 02 / Odoo 347310: цель клика по строке для конфига с page_binding / chips_binding → { page, workspace, chips } для pageGotoChip_runMany.
// get(binding) — значение поля строки (ссылка — {value, valueStr}). chips — JSON-строка или массив в формате плиток [{binding, values, title}]; нет / не разобрался —
// чипс из chip_binding + row_binding (если заданы), иначе переход без чипсов
export function pageGotoChip_rowTarget(cfg, get, display = undefined) {
    const scalar = (v) => isObj(v) ? v.value : v
    const page = (cfg.page_binding && str(scalar(get(cfg.page_binding))).trim()) || cfg.page
    let chips = cfg.chips_binding ? get(cfg.chips_binding) : null
    if (typeof chips === 'string') { try { chips = chips.trim() ? JSON.parse(chips) : null } catch (e) { chips = null } }
    if (!Array.isArray(chips) || !chips.length) {
        const val = cfg.chip_binding && cfg.row_binding ? pageGotoChip_value(get(cfg.row_binding), display) : null
        chips = val ? [{ binding: cfg.chip_binding, values: [val], condition: cfg.condition }] : []
    }
    return { page, workspace: cfg.workspace, chips }
}

// строка данных отчёта, по которой идём: не итог, не строка сравнения (_variant), не полоса / заголовок блока, не скрытая
export function pageGotoChip_rowIsData(dataItem) {
    if (!isObj(dataItem)) return false
    if (dataItem._variant) return false
    const d = dataItem._DLRow
    if (isObj(d)) {
        if (d.row_type === 'Total' || d.row_type === 'tab' || d.row_type === 'tabrow' || d.hide || d.memo) return false
    }
    return !dataItem._ogHide
}

// клик по колонке cfg.column (нет — любая; для trigger:row_header колонки нет — true): binding колонки грида может быть составным ('title.valueStr' у AttrMulti) — сравниваем и с первым звеном
export function pageGotoChip_columnOk(cfg, colBinding) {
    if (!cfg) return false
    if (cfg.trigger !== 'cell' || !cfg.column) return true
    const b = str(colBinding)
    return b === cfg.column || b.split('.')[0] === cfg.column
}

// значение ячейки строки → { value, valueStr } чипса; ссылка приходит объектом {value, valueStr}, число / строка — как есть; пусто — null
export function pageGotoChip_value(raw, rawStr = undefined) {
    let value = raw, valueStr = rawStr
    if (isObj(raw)) { value = raw.value; if (valueStr === undefined) valueStr = raw.valueStr }
    if (value === undefined || value === null || value === '' || (typeof value === 'number' && Number.isNaN(value)) || isObj(value) || Array.isArray(value)) return null
    return { value, valueStr: str(valueStr === undefined || valueStr === null || valueStr === '' ? value : valueStr) }
}

const lv = (row) => isObj(row) ? (isObj(row.leftValue) ? str(row.leftValue.value) : str(row.leftValue)) : ''

// есть ли в строках WHERE стола селектор с этим binding (служебные hidden / calc — не селекторы)
export function pageGotoChip_hasChip(WHERE, binding) {
    return (Array.isArray(WHERE) ? WHERE : []).some(r => isObj(r) && !r.hidden && lv(r) === str(binding))
}

// новые строки WHERE стола: чипс cfg.chip_binding = ровно одно значение (заменяет прежние), остальные строки — как были. Исходный массив не меняется.
// Строка чипса уже есть (в т. ч. выключенная) — use: true, attrs = значение; нет — новая AttrChipWhere. Возвращает { WHERE, created }
export function pageGotoChip_apply(WHERE, cfg, val) {
    const rows = clone(Array.isArray(WHERE) ? WHERE : [])
    if (!cfg || !val) return { WHERE: rows, created: false }
    const idx = rows.findIndex(r => isObj(r) && lv(r) === cfg.chip_binding)
    const tmpl = idx >= 0 && isObj(rows[idx].rightValue) ? rows[idx].rightValue : null
    const attr = { use: true, rightValue: { attr_type: (tmpl && tmpl.attr_type) || 'AttrLink', component: (tmpl && tmpl.component) || 'AttrLink',
        relation_segment: str((tmpl && tmpl.relation_segment) || ''), value: val.value, valueStr: val.valueStr } }
    if (idx >= 0) {
        const r = rows[idx]
        r.use = true
        if (!r.condition) r.condition = cfg.condition || 'in'
        r.attrs = [attr]
        if (isObj(r.rightValue)) r.rightValue = { ...r.rightValue, value: '', valueStr: '' }   // значения — только в attrs, как у строк бэка
        return { WHERE: rows, created: false }
    }
    rows.push({ use: true, attr_type: 'AttrChipWhere', condition: cfg.condition || 'in',
        leftValue: { value: cfg.chip_binding, valueStr: cfg.chip_binding, attr_type: 'AttrLink', component: 'AttrLink', relation_segment: '' },
        rightValue: { value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', relation_segment: '' },
        attrs: [attr] })
    return { WHERE: rows, created: true }
}

// ======================================================================= выполнение (стор передаётся параметром — юнит с заглушкой)
const identityT = (text, params) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (params && k in params) ? String(params[k]) : m)
const isActive = (store, ws, page) => store?.activeWORKSPACE?.workspace === ws && (!page || store.activeWORKSPACE.active_page === page)
const pageShown = (store, ws, page) => !!(store?.WORKSPACES?.[ws]?.ALL_WIDGETS || []).some(w => w && w.page === page && !w.close)

// Клик по строке: чипс — в память стола, переход на страницу cfg.page, отбор применяется к виджетам страницы.
//   - страница ещё не открывалась — флаг store._whereFromLink на время перехода: workspace_show_widgets применит отбор ДО открытия виджетов (страница грузится один раз);
//   - страница уже открыта (в т. ч. текущая) — после перехода workspace_applySelector: виджеты с приёмом селектора перечитываются;
//   - selector_version стола +1: страницы, открытые раньше (в т. ч. исходная), перечитают участников селекторов при возврате.
// В запись стола и в настройки пользователя ничего не пишется. ctx: t, notify(text, status), display (подпись значения), navWaitMs. Возвращает { ok, reason?, value? }
export async function pageGotoChip_run(store, WIDGET, cfg, dataItem, ctx = {}) {
    if (cfg && (cfg.page_binding || cfg.chips_binding)) {   // demo-webscm 2026 11 02 / Odoo 347310: страница / чипсы из строки — один переход со всеми чипсами
        if (!isObj(dataItem)) return { ok: false, reason: 'no-workspace' }
        return pageGotoChip_runMany(store, WIDGET, pageGotoChip_rowTarget(cfg, (b) => store.get_value(dataItem, b), ctx.display), ctx)
    }
    if (cfg && cfg.workspace && cfg.workspace !== str(WIDGET?.workspace)) return pageGotoChip_runOther(store, WIDGET, cfg, dataItem, ctx)
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    const notify = typeof ctx.notify === 'function' ? ctx.notify : () => {}
    const ws = str(WIDGET?.workspace)
    const W = store?.WORKSPACES?.[ws]
    const params = W?.record?.doc?.params
    if (!cfg || !params || !isObj(dataItem)) return { ok: false, reason: 'no-workspace' }
    if (!W.PAGES || !W.PAGES[cfg.page]) {
        notify(t('Page {page} was not found in this workspace', { page: cfg.page }), 'warning')
        return { ok: false, reason: 'no-page' }
    }
    const val = pageGotoChip_value(store.get_value(dataItem, cfg.row_binding), ctx.display)   // ctx.display — текст ячейки на экране (подпись чипса вместо id)
    if (!val) {
        notify(t('This row has no value for the filter — the page was not opened'), 'warning')
        return { ok: false, reason: 'no-value' }
    }
    const res = pageGotoChip_apply(params.WHERE, cfg, val)
    params.WHERE = res.WHERE
    delete params.calc_selectors_mark   // метка расчётных селекторов — пересчитает бэк на applySelector
    try { store.update_CHIPS_from_WHERE?.(params) } catch (e) { /* чипсы шапки — best effort */ }
    W.selector_version = (W.selector_version ?? 0) + 1
    const wasActive = isActive(store, ws, cfg.page), wasShown = wasActive || pageShown(store, ws, cfg.page)
    const prevFlag = store._whereFromLink
    if (!wasShown) store._whereFromLink = true
    let ok = false
    try { ok = await guidePlay_goto(store, ws, cfg.page, { settleMs: 0, navWaitMs: ctx.navWaitMs, sleep: ctx.sleep }) } finally { if (!wasShown) store._whereFromLink = prevFlag }
    if (!ok) {
        notify(t('The page could not be opened'), 'error')
        return { ok: false, reason: 'nav-timeout', value: val }
    }
    if (wasShown) store.workspace_applySelector(ws, cfg.page)
    return { ok: true, value: val, created: res.created }
}

// Другой стол (cfg.workspace): тот же путь, что у показа «Open in demo» (utils/guidePlay.js) — guidePlay_goto (роутер, ожидание активной страницы) и store.guideChips_pending,
// который забирает workspace_show_widgets: чипс ставится в память стола ДО открытия виджетов страницы (страница грузится один раз, _whereFromLink выставляет вызывающий).
// Стол загружен раньше — селектор и страница проверяются до перехода; не загружен — при открытии (нет селектора: чипс не ставится, тост, страница открывается как есть).
// Селектора в столе-цели нет — чипс НЕ создаётся (в отличие от своего стола). Стол уже показывал эту страницу — чипс в памяти и applySelector после перехода.
async function pageGotoChip_runOther(store, WIDGET, cfg, dataItem, ctx) {
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    const notify = typeof ctx.notify === 'function' ? ctx.notify : () => {}
    const tw = cfg.workspace
    if (!store || !isObj(dataItem)) return { ok: false, reason: 'no-workspace' }
    const val = pageGotoChip_value(store.get_value(dataItem, cfg.row_binding), ctx.display)
    if (!val) {
        notify(t('This row has no value for the filter — the page was not opened'), 'warning')
        return { ok: false, reason: 'no-value' }
    }
    const missing = () => notify(t('The filter {chip} is not available in workspace {workspace} — the chip was not set', { chip: cfg.chip_binding, workspace: tw }), 'warning')
    const W0 = store.WORKSPACES?.[tw]
    if (W0 && W0.record?.doc?.params) {   // стол уже загружен — проверки ДО перехода, побочных эффектов нет
        if (!W0.PAGES || !W0.PAGES[cfg.page]) { notify(t('Page {page} was not found in this workspace', { page: cfg.page }), 'warning'); return { ok: false, reason: 'no-page' } }
        if (!pageGotoChip_hasChip(W0.record.doc.params.WHERE, cfg.chip_binding)) { missing(); return { ok: false, reason: 'no-chip' } }
    }
    let rejected = false
    const apply = (W) => {
        const params = W?.record?.doc?.params
        if (!params) return false
        if (!pageGotoChip_hasChip(params.WHERE, cfg.chip_binding)) { rejected = true; missing(); return false }
        params.WHERE = pageGotoChip_apply(params.WHERE, cfg, val).WHERE
        delete params.calc_selectors_mark
        try { store.update_CHIPS_from_WHERE?.(params) } catch (e) { /* чипсы шапки — best effort */ }
        W.selector_version = (W.selector_version ?? 0) + 1
        return true
    }
    const wasShown = !!W0 && (isActive(store, tw, cfg.page) || pageShown(store, tw, cfg.page))
    const pend = { workspace: tw, page: cfg.page, apply }
    if (!wasShown) store.guideChips_pending = pend   // забирает workspace_show_widgets при первом открытии страницы
    // IE 2026 09 30 / ODOO-343433: стол ещё не загружен (обычный случай для гостя демо) — грузится дольше, чем у загруженного: ждём до 90 с
    let ok = false
    try { ok = await guidePlay_goto(store, tw, cfg.page, { settleMs: 0, navWaitMs: ctx.navWaitMs ?? (W0 ? 30000 : 90000), sleep: ctx.sleep }) } catch (e) { ok = false }
    if (!ok && !W0 && store.guideChips_pending === pend) {
        // стол всё ещё грузится: чипс остаётся ожидающим (как у тура: goto_page + set_chips через границу столов) и встанет при открытии страницы; не вечно — 4 минуты
        notify(t('The workspace is still loading — the filter will be applied when its page opens'), 'warning')
        const tm = setTimeout(() => { if (store.guideChips_pending === pend) store.guideChips_pending = null }, ctx.pendingTtlMs ?? 240000)
        if (tm && typeof tm.unref === 'function') tm.unref()   // node (юнит): таймер не держит процесс
        return { ok: false, reason: 'nav-timeout', value: val, pending: true }
    }
    if (store.guideChips_pending === pend) store.guideChips_pending = null
    if (!ok) {
        notify(t('The page could not be opened'), 'error')
        return { ok: false, reason: 'nav-timeout', value: val }
    }
    if (!pend.applied) {   // страница уже была построена (show_widgets не звался) — чипс в память и применить
        if (!apply(store.WORKSPACES?.[tw])) return { ok: false, reason: 'no-chip', value: val }
        store.workspace_applySelector(tw, cfg.page)
    }
    if (rejected) return { ok: false, reason: 'no-chip', value: val, navigated: true }
    return { ok: true, value: val, workspace: tw }
}

// ======================================================================= несколько чипсов за один клик
// webscm 2026 10 31 / Odoo 347310 (плитки KPI, AttrKpiTiles): клик ставит СРАЗУ НЕСКОЛЬКО чипсов, у каждого — СПИСОК значений, и открывает страницу ОДИН раз
// (pageGotoChip_run — один чипс с одним значением, и переход на каждый вызов). Функции выше не меняются.
// Чипс: { binding: '<binding селектора стола — как есть, напр. «object»: «doc.» не добавляется и не снимается>', values: [скаляр | {value, valueStr}],
//   title?: '<подпись значений>', condition?: 'in', relation_segment? }.
//   values: [] — чипс ВЫКЛЮЧИТЬ (use: false, значения сняты; как guideChips_apply): клик по всей плитке после клика по ячейке LT не оставит чипс горизонта.
//   Чипсы, которых нет в списке, остаются как были (в отличие от показа «Open in demo», который выключает «мои»). Переход без чипсов отбор стола не трогает.

// нормализованный список чипсов (пустой binding / без values и value — пропуск); значения — {value, valueStr}, пустые отбрасываются, повторы — один раз;
// одинаковый binding — значения объединяются. Скаляр без подписи: valueStr = title чипса, если значение одно (шапка покажет «Дефицит», а не «oos»), иначе само значение
export function pageGotoChip_chips(list) {
    const out = [], byBinding = new Map()
    for (const c of (Array.isArray(list) ? list : (isObj(list) ? [list] : []))) {
        if (!isObj(c)) continue
        const binding = str(c.binding).trim()
        if (!binding) continue
        const raw = Array.isArray(c.values) ? c.values : (c.values !== undefined ? [c.values] : (c.value !== undefined ? [c.value] : null))
        if (raw === null) continue
        const title = str(c.title).trim()
        const values = []
        for (const v of raw) {
            const val = pageGotoChip_value(v)
            if (val) values.push(raw.length === 1 && !isObj(v) && title ? { value: val.value, valueStr: title } : val)
        }
        let chip = byBinding.get(binding)
        if (!chip) {
            chip = { binding, values: [], title, condition: str(c.condition).trim(), relation_segment: str(c.relation_segment).trim() }
            byBinding.set(binding, chip)
            out.push(chip)
        }
        for (const v of values) if (!chip.values.some(x => str(x.value) === str(v.value))) chip.values.push(v)
        if (!chip.title) chip.title = title
        if (!chip.condition) chip.condition = str(c.condition).trim()
        if (!chip.relation_segment) chip.relation_segment = str(c.relation_segment).trim()
    }
    return out
}

// новые строки WHERE стола по списку чипсов; исходный массив не меняется. Строка с binding есть — use: есть значения, attrs = значения в форме строк бэка (как
// pageGotoChip_apply: rightValue строки опустошается); строки нет — новая AttrChipWhere, а при opts.create === false — binding в missing. Выключение (values: [])
// без строки — ничего. Возвращает { WHERE, set, cleared, created, missing }
export function pageGotoChip_applyMany(WHERE, chips, opts = {}) {
    const rows = clone(Array.isArray(WHERE) ? WHERE : [])
    const res = { WHERE: rows, set: [], cleared: [], created: [], missing: [] }
    const valueAttr = (v, tmpl, c) => ({ use: true, rightValue: { attr_type: (tmpl && tmpl.attr_type) || 'AttrLink', component: (tmpl && tmpl.component) || 'AttrLink',
        relation_segment: str((tmpl && tmpl.relation_segment) || c.relation_segment || ''), value: v.value, valueStr: v.valueStr } })
    for (const c of pageGotoChip_chips(chips)) {
        const idx = rows.findIndex(r => isObj(r) && lv(r) === c.binding)
        if (idx >= 0) {
            const r = rows[idx]
            const tmpl = isObj(r.rightValue) ? r.rightValue : null
            r.use = c.values.length > 0
            if (c.condition) r.condition = c.condition
            else if (!r.condition) r.condition = 'in'
            r.attrs = c.values.map(v => valueAttr(v, tmpl, c))
            if (isObj(r.rightValue)) r.rightValue = { ...r.rightValue, value: '', valueStr: '' }   // значения — только в attrs, как у строк бэка
            ;(c.values.length ? res.set : res.cleared).push(c.binding)
            continue
        }
        if (!c.values.length) continue
        if (opts.create === false) { res.missing.push(c.binding); continue }
        rows.push({ use: true, attr_type: 'AttrChipWhere', condition: c.condition || 'in',
            leftValue: { value: c.binding, valueStr: c.binding, attr_type: 'AttrLink', component: 'AttrLink', relation_segment: '' },
            rightValue: { value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', relation_segment: c.relation_segment },
            attrs: c.values.map(v => valueAttr(v, null, c)) })
        res.created.push(c.binding)
        res.set.push(c.binding)
    }
    return res
}

// Клик плитки: все чипсы target.chips — в память стола одним разом (selector_version +1 один раз), затем ОДИН переход на target.page; стол — target.workspace,
// нет / тот же — стол виджета. Пути те же, что у pageGotoChip_run (свой стол: _whereFromLink до первого открытия страницы, applySelector на уже открытой) и
// pageGotoChip_runOther (другой стол: guideChips_pending; селектора там нет — чипсы НЕ ставятся, ни один). Чипсов нет — только переход, отбор не трогается.
// ctx: t, notify(text, status), navWaitMs, sleep, pendingTtlMs. Возвращает { ok, reason?, set?, cleared?, created?, missing? }
export async function pageGotoChip_runMany(store, WIDGET, target, ctx = {}) {
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    const notify = typeof ctx.notify === 'function' ? ctx.notify : () => {}
    const page = str(target && target.page).trim()
    const tw = str(target && target.workspace).trim()
    const ws = str(WIDGET?.workspace)
    const chips = pageGotoChip_chips(target && target.chips)
    if (!store || !page) return { ok: false, reason: 'no-page' }
    if (tw && tw !== ws) return runManyOther(store, tw, page, chips, ctx, t, notify)
    const W = store.WORKSPACES?.[ws]
    const params = W?.record?.doc?.params
    if (!params) return { ok: false, reason: 'no-workspace' }
    if (!W.PAGES || !W.PAGES[page]) {
        notify(t('Page {page} was not found in this workspace', { page }), 'warning')
        return { ok: false, reason: 'no-page' }
    }
    let res = null
    if (chips.length) {
        res = pageGotoChip_applyMany(params.WHERE, chips)
        params.WHERE = res.WHERE
        delete params.calc_selectors_mark   // метка расчётных селекторов — пересчитает бэк на applySelector
        try { store.update_CHIPS_from_WHERE?.(params) } catch (e) { /* чипсы шапки — best effort */ }
        W.selector_version = (W.selector_version ?? 0) + 1
    }
    const wasShown = isActive(store, ws, page) || pageShown(store, ws, page)
    const flag = !!res && !wasShown, prevFlag = store._whereFromLink
    if (flag) store._whereFromLink = true
    let ok = false
    try { ok = await guidePlay_goto(store, ws, page, { settleMs: 0, navWaitMs: ctx.navWaitMs, sleep: ctx.sleep }) } finally { if (flag) store._whereFromLink = prevFlag }
    if (!ok) {
        notify(t('The page could not be opened'), 'error')
        return { ok: false, reason: 'nav-timeout' }
    }
    if (res && wasShown) store.workspace_applySelector(ws, page)
    return { ok: true, set: res ? res.set : [], cleared: res ? res.cleared : [], created: res ? res.created : [] }
}

async function runManyOther(store, tw, page, chips, ctx, t, notify) {
    const setting = chips.filter(c => c.values.length)   // выключения отсутствующего селектора — не ошибка: выключать нечего
    const missingIn = (WHERE) => setting.filter(c => !pageGotoChip_hasChip(WHERE, c.binding)).map(c => c.binding)
    const missing = (list) => notify(t('The filter {chip} is not available in workspace {workspace} — the chip was not set', { chip: list.join(', '), workspace: tw }), 'warning')
    const W0 = store.WORKSPACES?.[tw]
    if (W0 && W0.record?.doc?.params) {   // стол уже загружен — проверки ДО перехода, побочных эффектов нет
        if (!W0.PAGES || !W0.PAGES[page]) { notify(t('Page {page} was not found in this workspace', { page }), 'warning'); return { ok: false, reason: 'no-page' } }
        const miss = missingIn(W0.record.doc.params.WHERE)
        if (miss.length) { missing(miss); return { ok: false, reason: 'no-chip', missing: miss } }
    }
    let rejected = null
    const apply = (W) => {
        const params = W?.record?.doc?.params
        if (!params) return false
        const miss = missingIn(params.WHERE)
        if (miss.length) { rejected = miss; missing(miss); return false }
        params.WHERE = pageGotoChip_applyMany(params.WHERE, chips, { create: false }).WHERE
        delete params.calc_selectors_mark
        try { store.update_CHIPS_from_WHERE?.(params) } catch (e) { /* чипсы шапки — best effort */ }
        W.selector_version = (W.selector_version ?? 0) + 1
        return true
    }
    const wasShown = !!W0 && (isActive(store, tw, page) || pageShown(store, tw, page))
    const pend = chips.length ? { workspace: tw, page, apply } : null
    if (pend && !wasShown) store.guideChips_pending = pend   // забирает workspace_show_widgets при первом открытии страницы
    let ok = false
    try { ok = await guidePlay_goto(store, tw, page, { settleMs: 0, navWaitMs: ctx.navWaitMs ?? (W0 ? 30000 : 90000), sleep: ctx.sleep }) } catch (e) { ok = false }
    if (!ok && pend && !W0 && store.guideChips_pending === pend) {
        notify(t('The workspace is still loading — the filter will be applied when its page opens'), 'warning')
        const tm = setTimeout(() => { if (store.guideChips_pending === pend) store.guideChips_pending = null }, ctx.pendingTtlMs ?? 240000)
        if (tm && typeof tm.unref === 'function') tm.unref()   // node (юнит): таймер не держит процесс
        return { ok: false, reason: 'nav-timeout', pending: true }
    }
    if (pend && store.guideChips_pending === pend) store.guideChips_pending = null
    if (!ok) {
        notify(t('The page could not be opened'), 'error')
        return { ok: false, reason: 'nav-timeout' }
    }
    if (pend && !pend.applied) {   // страница уже была построена (show_widgets не звался) — чипсы в память и применить
        if (!apply(store.WORKSPACES?.[tw])) return { ok: false, reason: 'no-chip', missing: rejected || [], navigated: true }
        store.workspace_applySelector(tw, page)
    }
    if (rejected) return { ok: false, reason: 'no-chip', missing: rejected, navigated: true }
    return { ok: true, workspace: tw }
}

export default { pageGotoChip_config, pageGotoChip_rowIsData, pageGotoChip_columnOk, pageGotoChip_value, pageGotoChip_apply, pageGotoChip_hasChip, pageGotoChip_run, PAGE_GOTO_CHIP_ACTION,
    pageGotoChip_chips, pageGotoChip_applyMany, pageGotoChip_runMany,   // webscm 2026 10 31 / Odoo 347310
    pageGotoChip_rowTarget }   // demo-webscm 2026 11 02 / Odoo 347310
